import { render } from "./환경성질환.vue?vue&type=template&id=54ba026a"
import script from "./환경성질환.vue?vue&type=script&lang=js"
export * from "./환경성질환.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__